import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { getCompanyMasterByRefID, postCompanyMaster } from "../api/teeTimeAPI";

const AddGSTNumber = ({ setSelectCompany, refID, selectCompany, onDismissModal }) => {
    const [gstDetails, setGstDetails] = useState({});
    const [gstList, setGstList] = useState([]);

    useEffect(() => {
        $('#modalCompany').modal({
            backdrop: 'static',
        });
        $('#modalCompany').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            onDismissModal(false);
        });
    }, []);

    useEffect(() => {
        if (refID != null) fetchCompanyMaster(refID);
    }, [refID]);

    useEffect(() => {
        if (!!selectCompany) setGstDetails(selectCompany);
    }, [selectCompany]);

    const updateGSTDetails = (field, value) => {
        setGstDetails((prev) => ({ ...prev, [field]: value }));
    };

    const fetchCompanyMaster = async (refID) => {
        try {
            const master = await getCompanyMasterByRefID(refID);
            setGstList(master.CompanyList);
        } catch (error) {
            Swal.fire({ icon: 'error', titleText: error.message });
        }
    };

    const saveGSTHandler = async (e) => {
        e.preventDefault();
        if (!gstDetails.CompanyName || !gstDetails.GSTNumber) {
            Swal.fire({ icon: "error", title: "Error!", text: "Please fill in all required fields" });
            return;
        }

        await postCompanyMaster({ ...gstDetails, RefID: refID, Active: "Y" });
        setSelectCompany(gstDetails);
        setGstDetails({})

        $('#modalCompany').modal('hide');
        Swal.fire({ icon: "success", title: "Saved!", text: "GST details added successfully", timer: 1500 });
    };

    const selectGST = (company) => {
        setSelectCompany(company);
        $('#modalCompany').modal('hide');
    };

    const removeCompany = () => {
        setSelectCompany(null);
        onDismissModal(false);
        $('#modalCompany').modal('hide');
    };

    return (
        <div id="modalCompany" className="modal fade modal-responsive" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button>
                        <h4 id="modalCompanyTitle" className="modal-title">Add GST Number</h4>
                    </div>
                    <div className="modal-body">
                        <div id="ModalCompanyHolder" noValidate="novalidate" className="bv-form">
                            <div id="messageCompanyModel" style={{ display: "none" }}></div>

                            {gstList.length > 0 && (
                                <div id="pnlCompany" className="">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <h5 className="text-center">Select Company</h5>
                                        </div>
                                    </div>

                                    <table id="tblCompany" className="table table-bordered table-hover">
                                        <thead className="thin-border-bottom">
                                            <tr>
                                                <th>Company</th>
                                                <th>GST No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {gstList.map((company, index) => (
                                                <tr key={index} onClick={() => selectGST(company)} style={{ cursor: "pointer" }}>
                                                    <td>{company.CompanyName}</td>
                                                    <td>{company.GSTNumber}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <hr className="divider" />
                                </div>
                            )}

                            <div className="row">
                                <div className="col-xs-12">
                                    <h5 className="text-center">New Company</h5>
                                </div>
                            </div>

                            <div id="companyForm" role="form">
                                <div className="form-group">
                                    <input
                                        id="txtCompanyName"
                                        name="txtCompanyName"
                                        type="text"
                                        className="form-control"
                                        placeholder="Company Name"
                                        value={gstDetails.CompanyName || ''}
                                        onChange={(event) => updateGSTDetails("CompanyName", event.target.value)}
                                    />
                                    <small data-bv-validator="notEmpty" data-bv-validator-for="txtCompanyName" className="help-block" style={{ display: "none" }}>This field is required</small>
                                </div>
                                <div className="form-group">
                                    <input
                                        id="txtCompanyGstNo"
                                        name="txtCompanyGstNo"
                                        type="text"
                                        className="form-control"
                                        placeholder="GST Number"
                                        value={gstDetails.GSTNumber || ''}
                                        onChange={(event) => updateGSTDetails("GSTNumber", event.target.value)}
                                    />
                                    <small data-bv-validator="notEmpty" data-bv-validator-for="txtCompanyGstNo" className="help-block" style={{ display: "none" }}>This field is required</small>
                                    <small data-bv-validator="stringLength" data-bv-validator-for="txtCompanyGstNo" className="help-block" style={{ display: "none" }}>Enter a 15 digit valid GST number</small>
                                </div>
                                <div className="form-group">
                                    <textarea
                                        name="txtCompanyAddress"
                                        rows="2"
                                        cols="20"
                                        id="txtCompanyAddress"
                                        className="form-control"
                                        placeholder="Address"
                                        value={gstDetails.Address || ''}
                                        onChange={(event) => updateGSTDetails("Address", event.target.value)}
                                    ></textarea>
                                    <small data-bv-validator="notEmpty" data-bv-validator-for="txtCompanyAddress" className="help-block" style={{ display: "none" }}>This field is required</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        {selectCompany && (
                            <button type="button" id="btnRemoveCompany" name="btnRemoveCompany" className="btn btn-danger" onClick={removeCompany}>Remove</button>
                        )}
                        <button type="button" id="btnSaveCompany" name="btnSaveCompany" className="btn btn-success" onClick={saveGSTHandler}>{selectCompany?"Update":"Add"}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddGSTNumber;